import * as React from 'react'
import { useUserPlan } from '../auth/plans/useUserPlan';

type PropsQuestion = {
  question: React.ReactElement | string,
  answer: React.ReactElement | string
}


const RankingFaqQuestion: React.FC<PropsQuestion> = ({ question, answer }) => {
  const [open, setOpen] = React.useState<boolean>(false);
  return (
    <div>
      <div className=' text-sm hover:text-viking-700 cursor-pointer pb-1' 
      onClick={() => setOpen(!open)}>
        {question}
      </div>
      {open &&
        <div className='pb-2 max-w-[400px] border-t border-gray-500 pt-1 text-base'>
          {answer}
          </div>
      }

    </div>
  );
}

type Props = {

}

const RankingFaq: React.FC<Props> = ({ }) => {
  const plan = useUserPlan();
  const isSubscriber = plan?.plan === 'SUBSCRIBED';
  return (
    <div className='flex gap-2 flex-wrap'>      
    {!isSubscriber &&
            <RankingFaqQuestion
            question="How can I see all nodes?"
            answer={<div>
              Only nodes that have an active LnRouter Plan are listed on this site publicly.
              If you wish to see all available nodes that have been scanned you need to purchase an LnRouter Plan yourself.
            </div>}
          />
      }
      <RankingFaqQuestion
        question="How can my node rank on this list?"
        answer={<div>
          Your node will be displayed on this list if it is part of a 
          <a href="https://blog.lnrouter.app/liquidity-scan" target="_blank"
          className='text-viking-700 hover:text-viking-800 ml-1'>
            Liquidity Scan</a>. To make it visible to users without a subscription,
            you need to have an active LnRouter Plan and a routing score of 50 or higher.
        </div>}
      />


    </div>
  );
}

export default RankingFaq;

